import api from './api';
import { nullableUuid } from '@/utils/uuid';

export type EstoqueMovimentacaoTipo = 'ENTRADA' | 'SAIDA' | 'TRANSFERENCIA' | 'AJUSTE' | 'PRODUCAO' | 'DEVOLUCAO';

export interface EstoqueMovimentacao {
  id: string;
  tipo: EstoqueMovimentacaoTipo;
  produto_id: string;
  produto_codigo?: string | null;
  produto_descricao?: string | null;
  produto_nome?: string | null;
  lote_id?: string | null;
  lote_numero?: string | null;
  quantidade: number;
  data_movimento: string;
  origem_id?: string | null;
  origem_descricao?: string | null;
  destino_id?: string | null;
  destino_descricao?: string | null;
  documento?: string | null;
  op_id?: string | null;
  op_numero?: string | null;
  responsavel_id?: string | null;
  responsavel_nome?: string | null;
  observacoes?: string | null;
  sincronizado_erp?: boolean;
  sincronizado_erp_em?: string | null;
  sincronizado_erp_erro?: string | null;
  sincronizado_erp_status?: string;
}

export interface EstoqueMovimentacaoInput {
  tipo: EstoqueMovimentacaoTipo;
  produto_id: string;
  lote_id?: string | null;
  quantidade: number;
  data_movimento?: string | null;
  origem_id?: string | null;
  destino_id?: string | null;
  documento?: string | null;
  op_id?: string | null;
  responsavel_id?: string | null;
  observacoes?: string | null;
}

const ENDPOINT = '/industrializacao/estoque-movimentacao';

const estoqueMovimentacaoService = {
  async listar(filters: { tipo?: string; produto?: string; lote?: string; op?: string } = {}): Promise<EstoqueMovimentacao[]> {
    const response = await api.get<EstoqueMovimentacao[]>(ENDPOINT, { params: filters });
    return response.data;
  },
  async buscarPorId(id: string): Promise<EstoqueMovimentacao> {
    const response = await api.get<EstoqueMovimentacao>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: EstoqueMovimentacaoInput): Promise<EstoqueMovimentacao> {
    const response = await api.post<EstoqueMovimentacao>(ENDPOINT, {
      ...data,
      produto_id: nullableUuid(data.produto_id) || '',
      lote_id: nullableUuid(data.lote_id),
      origem_id: nullableUuid(data.origem_id),
      destino_id: nullableUuid(data.destino_id),
      op_id: nullableUuid(data.op_id),
      responsavel_id: nullableUuid(data.responsavel_id),
    });
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
  /** Forca a sincronizacao manual de uma movimentacao com o ERP legado */
  async forcarSyncErp(id: string): Promise<{ success: boolean; message?: string; error?: string }> {
    const response = await api.post(`${ENDPOINT}/${id}/forcar_sync_erp`);
    return response.data;
  },
};

export default estoqueMovimentacaoService;
